// The texts every widget shares come from the pinned VisionPlatform copy (P-112), loaded as the `widget`
// namespace. strings.json is flat ("age.minutes"); i18next nests keys at the dots, so it is unflattened here.
import strings from "../../contracts/fixtures/widgets/strings.json";

type Nested = { [k: string]: string | Nested };

function nest(flat: Record<string, string>): Nested {
  const out: Nested = {};
  for (const [key, text] of Object.entries(flat)) {
    const parts = key.split(".");
    let node = out;
    for (const p of parts.slice(0, -1)) {
      const next = node[p];
      node = typeof next === "object" ? next : (node[p] = {});
    }
    node[parts.at(-1) ?? key] = text;
  }
  return out;
}

export const widgetStrings = { en: nest(strings.en), ro: nest(strings.ro) };
